import { render, staticRenderFns } from "./TripNoteListItem.vue?vue&type=template&id=e48d3ea2&scoped=true&"
import script from "./TripNoteListItem.vue?vue&type=script&lang=js&"
export * from "./TripNoteListItem.vue?vue&type=script&lang=js&"
import style0 from "./TripNoteListItem.vue?vue&type=style&index=0&id=e48d3ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48d3ea2",
  null
  
)

export default component.exports